import { useContext } from "react";

import Context from "./MediaManagerContext";

const useMediaManagerContext = () => useContext(Context);

export default useMediaManagerContext;
